import { message } from 'antd';
import { client } from '../../../actions';

const BAD_REQUEST_MESSAGE =
  'Не удалось отправить код подтверждения. Попробуйте позже или выберите другой способ.';
const SERVICE_UNAVAILABLE_MESSAGE =
  'Не удалось связаться с сервисом отправки кода';
const TIMEOUT_MESSAGE =
  'Превышено время ожидания ответа сервиса отправки кода. Попробуйте позже.';
const DEFAULT_ERROR_MESSAGE = 'Не получилось получить код';

const getServerDescription = (data) => {
  if (!data) return '';

  if (typeof data === 'string') return data;

  return data.description || data.message || data.error || '';
};

const getVerificationCodeErrorMessage = (error) => {
  const status = error?.response?.status;
  const description = getServerDescription(error?.response?.data);

  if (status === 400) {
    return BAD_REQUEST_MESSAGE;
  }

  if (status === 503) {
    return description
      ? `${SERVICE_UNAVAILABLE_MESSAGE}: ${description}`
      : `${SERVICE_UNAVAILABLE_MESSAGE}. Попробуйте позже.`;
  }

  if (status === 504) {
    return TIMEOUT_MESSAGE;
  }

  return DEFAULT_ERROR_MESSAGE;
};

export const getVerificationCode = async ({
  authParameter,
  verificationTypeId,
}) => {
  try {
    const response = await client.post(
      '/TwoFactAuth/get_verification_code_web',
      { authParameter, verificationTypeId },
      {}
    );
    return response.data;
  } catch (e) {
    console.error(e);
    message.error(getVerificationCodeErrorMessage(e));
    return null;
  }
};
